import React from "react";
import services from "../../assets/fake-data/servicies/servicies";

const ServiciesSection = () => {
  return (
    <>
      <section className="py-20 bg-white">
        <div className="container">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 gap-[30px]">
            {services.map((x) => {
              return (
                <div key={x.id} className="text-center p-4">
                  <div>
                    <i
                      className={`${x.icon} text-white/80 text-[40px] leading-[84px] text-center w-[84px] h-[84px] inline-block bg-custom rounded-[10px]`}
                    ></i>
                  </div>
                  <div className="mt-6">
                    <h4 className="font-bold text-2xl">{x.title}</h4>
                    <p className="text-muted mt-4">{x.subTitle}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default ServiciesSection;
